export default {
    container: {
        backgroundColor: '#fff',
        borderRadius: 15,
        boxShadow: '0 13px 40px rgba(0,0,0,0.04), 0 13px 40px rgba(0,0,0,0.04)',
        border: [1, 'solid', '#ebebeb'],
        padding: 20,
        fontFamily: ['Roboto', 'open sans', 'Arial']
    }
};
